import { render } from "./associations.vue?vue&type=template&id=170ea9dd"
import script from "./associations.vue?vue&type=script&lang=js"
export * from "./associations.vue?vue&type=script&lang=js"

import "./associations.vue?vue&type=style&index=0&id=170ea9dd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__